/**
 * Created by chenzheyu on 2017/6/21.
 */
import XKinvoiceRecordMod from './src/invoiceRecordMod.vue'

XKinvoiceRecordMod.intall = function (Vue) {
  Vue.component(XKinvoiceRecordMod.name, XKinvoiceRecordMod)
}

export default XKinvoiceRecordMod



// WEBPACK FOOTER //
// ./src/components/module/invoiceRecordMod/index.js